import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IReopenReason, IStatus } from './interfaces';

export const getReopenReasonList = (data: IDynamicTableParams) => {
  return instance()
    .post<IReopenReason[]>('/dictionary/reopenReason/list', data)
    .then((response) => response.data);
};

export const getReopenReasonAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/dictionary/reopenReason/availableColumns')
    .then((response) => response.data);
};

export const getReopenReasonAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/dictionary/reopenReason/availableGroupColumns')
    .then((response) => response.data);
};

export const createReopenReason = (reopenReason: IReopenReason) => {
  return instance()
    .post('/dictionary/reopenReason/save', reopenReason)
    .then((response) => response.data);
};

export const updateReopenReason = (reopenReason: IReopenReason) => {
  return instance()
    .post('/dictionary/reopenReason/update', reopenReason)
    .then((response) => response.data);
};

export const deleteReopenReason = (changeStatusReasonId: number) => {
  return instance()
    .post('/dictionary/reopenReason/delete', { changeStatusReasonId })
    .then((response) => response.data);
};

export const recoverReopenReason = (changeStatusReasonId: number) => {
  return instance()
    .post('/dictionary/reopenReason/recover', { changeStatusReasonId })
    .then((response) => response.data);
};

export const loadReopenReason = (changeStatusReasonId: number) => {
  return instance()
    .post<IReopenReason>('/dictionary/reopenReason/get', { changeStatusReasonId })
    .then((response) => response.data);
};

export const getStatuses = () => {
  return instance()
    .post<IStatus[]>('/dictionary/status', {})
    .then((response) => response.data);
};
